import React from "react";
import * as ConnectionComps from "@repoflow/components/connection";
import * as AppComps from "@repoflow/components/app";
import * as ObservabilityComps from "@repoflow/components/observability";
import Routes from "./routes";
import { basename, rum } from "env"

ObservabilityComps.init(rum);

function App() {
      const client = ConnectionComps.get("/api/graphql");

      return (
            <AppComps.Provider client={client} basename={basename}>
                  <Routes />
            </AppComps.Provider>
      );
}

export default App;
